<template>
  <div class="login-chat">
    <div id="chat-messages">
      <div v-for="(msg, index) in chat" class="message" :class="msg.author + ' ' + msg.avatar" :key="index">
        <span v-if="msg.type === 'text'">{{ msg.msg }}</span>
        <button v-else-if="msg.type === 'button'" :value="msg.href" v-on:click="buttonClick" :data-index="index">{{ msg.msg }}</button>
        <a v-else-if="msg.type === 'link'" :href="msg.href" class="button">{{ msg.msg }}</a>
      </div>
    </div>

    <div class="input-wrapper">
      <label for="search-field" v-if="showPlaceholder">Name of your school, school board or organization?</label>
      <input data-cy="search" type="text" tabindex="2" name="search-field" id="search-field" v-model="currentMessage" v-on:keyup.enter="submit" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginFinder',
  data () {
    return {
      chat: [
        {author: 'bot', type: 'text', msg: 'What is the name of your school, school board or organization?', avatar: 'avatar'}
      ],
      numButtons: 0,
      search: '',
      lmsSearch: '',
      currentMessage: '',
      showPlaceholder: true
    }
  },
  mounted () {
    document.getElementById('search-field').focus()
  },
  methods: {
    submit: function (event) {
      this.response('user', 'text', this.currentMessage)

      // save the users input and clear it so the input field clears
      this.search = this.currentMessage.toLowerCase()
      this.currentMessage = ''

      this.botResponse()
    },
    buttonClick: function (event) {
      // remove the buttons that were not selected
      this.buttonResponse(event.target.textContent)
      this.findLMS(event.target.value)
    },
    buttonResponse: function (text) {
      // remove button responses
      this.search = text.toLowerCase()
      this.chat = this.chat.splice(0, this.chat.length - this.numButtons)
      this.numButtons = 0
      this.response('user', 'text', text)
    },
    botResponse: async function () {
      const self = this

      const baseURI = process.env.LMS_DISCO

      const edgeCases = { // Edge case object to quickly replace common search terms with better search to return results
        'anahuac mayab': 'anahuac',
        'anáhuac': 'anahuac',
        'ashworth': 'parent organization',
        'ashworth college': 'parent organization',
        'broward college': 'broward',
        'camosun college': 'camosun',
        'central piedmont community college': 'central piedmont',
        'conestoga college': 'conestoga',
        'dcdsb': 'durham cdsb',
        'lone star college': 'lscs',
        'lonestar college': 'lscs',
        'pace university': 'paceu',
        'perry high school': 'perry',
        'perry public schools': 'perry',
        'rochester institue of technology': 'rit',
        'san pablo colleges': 'san pablo',
        'traverse city area public school': 'traversecity',
        'tshwane university of technology': 'tut',
        'university of southern california': 'usc',
        'vidyashilp academy': 'vidyashilp',
        'wentworth institute of technology': 'wentworth',
        'wright state university': 'wright state'
      }

      const takeFirstResultCases = { // In some cases there are searches where they only want the first result to taken
        // 'halton catholic district school board': true
      }

      if (self.search.match(/thanks?( you)?/i)) {
        self.response('bot', 'text', 'Happy to help')
        return
      }

      self.response('bot', 'text', '...')

      if (edgeCases[self.search] !== undefined) { // Check edge cases
        self.search = edgeCases[self.search]
      }

      // Async fetch API call
      const result = await fetch(`${baseURI}${self.search}`)
      const data = await result.json()

      self.chat.pop()

      const entries = data.entities

      if (typeof entries === 'undefined') {
        if (self.search.indexOf('district school board') > -1) {
          // In some cases these names have been shorted to DSB or CDSB
          self.search = self.search.replace(/district school board/i, 'DSB')
          self.search = self.search.replace(/catholic dsb/i, 'CDSB')
          self.botResponse()
        } else {
          self.response('bot', 'text', 'Sorry, I didn\'t find any results for ' + self.search)
          self.response('bot', 'text', 'Please contact your Brightspace Administrator for further assistance')
          self.datalayerPush('fail')
        }
        return
      }

      if (entries.length === 1) {
        // self.lmsSearch = entries[0].links
        self.findLMS(entries[0].links[1].href)
        return
      }

      if (takeFirstResultCases[self.search] === undefined) {
        self.response('bot', 'text', 'Here are the results I found for ' + self.search)
        self.response('bot', 'text', 'Select one of the options below, or try another search', '', '')
        self.datalayerPush('multiple')

        // entries.forEach(function (item) {
        //   self.numButtons++
        //   self.response('user', 'button', item.properties.name, item.links[1].href)
        // })
        const MAX_RESULTS = 5
        const resultsToShow = (entries.length <= MAX_RESULTS) ? entries.length : MAX_RESULTS

        for (let i = 0; i < resultsToShow; i++) {
          self.numButtons++
          self.response('user', 'button', entries[i].properties.name, entries[i].links[1].href)
        }
        return
      }

      // Check first if there is an exact match with the very first result. If so return it instead of the too many results error.
      if (entries[0].properties.name.toLowerCase() === self.search) {
        // self.lmsSearch = entries[0].entities[0].href
        self.findLMS(entries[0].links[1].href)
      } else {
        self.response('bot', 'text', 'There were too many results.')
        self.response('bot', 'text', 'Please be a little more specific.', '', '')
        self.datalayerPush('multiple')
      }
    },
    findLMS: async function (url) {
      const self = this

      self.response('bot', 'text', '...')
      await this.sleep(500)
      self.chat.pop()

      if (typeof url === 'undefined') {
        self.response('bot', 'text', 'It doesn\'t looks like we have your login page')
        self.datalayerPush('fail')
        return
      }

      self.response('bot', 'text', 'Here is the link for your login page')
      self.response('bot', 'text', 'Click the link below to go there now', '', '')
      self.response('user', 'link', url, url)
      self.datalayerPush('success')

      // In case of an incident, we can use this to give users feedback on what is going on.
      /* if (self.search.indexOf('michigan state') !== -1) {
        self.response('bot', 'text', 'Please be aware there is an service outage that MSU is working to resolve')
        self.response('user', 'link', 'View incident', 'https://servicestatus.msu.edu/incidents/154074')
      } */
    },
    sleep: function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    datalayerPush: function (type) {
      const dataLayer = window.dataLayer || [] // ensure datalayer available
      dataLayer.push({'event': 'login-finder', 'login-finder-status': type, 'login-search-term': this.search})
    },
    scrollToBottom: function () {
      const container = document.querySelector('#chat-messages')
      const scrollHeight = container.scrollHeight
      container.scrollTop = scrollHeight + 300
    },
    response: function (author, type, msg, href = '', avatar = 'avatar') {
      this.chat.push({author: author, type: type, msg: msg, href: href, avatar: avatar})
    }
  },
  watch: {
    chat: function () {
      const self = this

      // Delay the scroll to the botton by a fraction of a second
      setTimeout(function () {
        self.scrollToBottom()
      }, 10)
    },
    currentMessage () {
      if (this.currentMessage !== '') {
        this.showPlaceholder = false
      } else {
        this.showPlaceholder = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.login-chat {
  width: 100%;
  background: #fff;
  border-radius: 16px;
  padding: 50px;
  border: 1px solid #bec3cd;
}

#chat-messages {
  --bot-color: var(--primary-color-40);
  --human-color: var(--primary-color-80);

  display: flex;
  flex-direction: column;

  height: 600px;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 0;
}

.message {
  text-align: left;
  width: 100%;
  clear: both;
}

#chat-messages .message span,
#chat-messages button,
#chat-messages a.button {
    font-family: "ars-maquette-web", Arial, Helvetica, sans-serif;
    font-size: 16px;

    max-width: 70%;
    padding: 10px 20px;
    border-radius: 30px;
    margin: 5px 0;
    text-align: right;
    float: left;
    color: var(--d2lWhite);
    display: inline-block;

    text-align: left;
}

@media (max-width: 992px) {
  .logo {
    text-align: center;
  }
  .white-shadow-box {
    padding: 20px;
  }
  #chat-messages {
    height: 370px;
  }
  #chat-messages .message span,
  #chat-messages button,
  #chat-messages a.button {
    max-width: 80%;
  }
}

#chat-messages .bot span {
    text-align: left;
    background-color: var(--bot-color);
    color: var(--dark-text-color);
}

div.bot:before {
  content: '';
  background-size: cover;
  width: 40px;
  height: 40px;

  border-radius: 50%;

  margin-right: 5px;
  margin-top: 5px;
  display: inline-block;
  float: left;
}

#chat-messages .user {
  justify-content: end;
}

#chat-messages .user span {
    background-color: var(--human-color);
    color: white;
    float: right;
}

#chat-messages .user button,
#chat-messages .user a {
    background: none;
    border: 2px solid var(--human-color);
    color: var(--human-color);
    float: right;

    text-decoration: none;

    cursor: pointer;
}

#chat-messages .user button:hover,
#chat-messages .user a:hover,
#chat-messages .user button:focus,
#chat-messages .user a:focus {
  background: var(--human-color);
  color: white;
  outline: none;
}

.input-wrapper {
  position: relative;
}

.login-chat label {
  position: absolute;
  z-index: 1;

  top: 22px;
  left: 5px;

  font-weight: normal;
  font-size: 16px;
  margin: 0;
}

.login-chat input {
  position: relative;
  z-index: 2;

  background: none;

  width: 100%;
  padding: 20px 5px 5px !important;

  display: block;
  border: none;
  border-top: 1px solid #ccc;
  border-radius: unset;
}

.login-chat input:focus {
  outline: none;
}

.footer-text {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginFinder.vue